"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengeProcessor = exports.RemoveRememberedUsername = exports.GetRememberedUsername = exports.getChallenges = void 0;
const tslib_1 = require("tslib");
const ChallengeType_1 = require("../enums/ChallengeType");
const Validations_1 = require("../enums/Validations");
const ChallengeStatus_1 = require("../enums/ChallengeStatus");
const MachineSecretManager_1 = tslib_1.__importDefault(require("../lib/MachineSecretManager"));
async function getChallenges() {
    const response = await fetch('/Authentication/Challenges');
    if (!response.ok) {
        throw new Error(await response.text());
    }
    const data = (await response.json());
    return data;
}
exports.getChallenges = getChallenges;
async function GetRememberedUsername(configuration) {
    const response = await fetch(`${configuration.rootUrl}API/Isotope/GetRememberedUsername`, {
        headers: {
            'Content-Type': 'application/json',
            'BankIdentifier': configuration.clientKey,
            'BankInstanceIdentifier': configuration.bii,
            'BankUri': configuration.bankUri,
        },
        method: 'GET',
    });
    if (!response.ok) {
        return '';
    }
    return (await response.json());
}
exports.GetRememberedUsername = GetRememberedUsername;
async function RemoveRememberedUsername(configuration) {
    await fetch(`${configuration.rootUrl}API/Isotope/RememberedUsername`, {
        method: 'DELETE',
    });
}
exports.RemoveRememberedUsername = RemoveRememberedUsername;
class ChallengeProcessor {
    constructor(context, request) {
        this.context = context;
        this.request = request;
        this.response = null;
        this.preSubmitChallenge();
    }
    // Any logic needed prior to sending the request
    preSubmitChallenge() {
        // Remove any server errors when submitting a new challenge
        this.context.state.errors = [];
        if (this.request.ChallengeTypeValue === ChallengeType_1.ChallengeType.Tethered) {
            this.request.ChallengeTypeValue = ChallengeType_1.ChallengeType.UsernameAndPassword;
        }
        // CheckSyncResult uses state.checkSyncResultChallenge instead of state.currentChallenge
        if (this.request.ChallengeTypeValue !== ChallengeType_1.ChallengeType.CheckSyncResult) {
            this.context.commit('isSubmittingChallenge', true);
            // Update the challenge being submitted with the correct nonce and progression the webapp sent last
            const lastSentResponse = this.context.state.currentChallenge;
            if (lastSentResponse.Nonce && lastSentResponse.Progression.length) {
                this.request.Nonce = lastSentResponse.Nonce;
                this.request.Progression = lastSentResponse.Progression;
            }
        }
    }
    async submitChallenge() {
        const username = this.request.Username;
        const challengeType = this.request.ChallengeTypeValue;
        if (challengeType === ChallengeType_1.ChallengeType.UsernameAndPassword) {
            MachineSecretManager_1.default.machineSecretProvider.initialize(username);
        }
        const configuration = this.context.state.configuration;
        const rememberUsername = this.context.state.rememberUsername;
        const sessionInfo = {
            AdditionalParameters: {
                isMobile: configuration.baseUrl != null && configuration.baseUrl.toLowerCase().includes('mobile')
                    ? 'true'
                    : 'false',
                rememberUserName: rememberUsername ? 'true' : 'false',
                persistentSessionIdentifier: typeof Global_PersistentSessionIdentifier === 'string' ? Global_PersistentSessionIdentifier : '',
                isTetheredLogin: configuration.initialChallengeType === ChallengeType_1.ChallengeType.Tethered ? 'true' : 'false',
            },
            Id: configuration.sessionId,
            MachineInfo: MachineSecretManager_1.default.machineSecretProvider.read(),
        };
        if (configuration.turnstileEnabled && challengeType === ChallengeType_1.ChallengeType.UsernameAndPassword) {
            sessionInfo.AdditionalParameters.token = this.context.state.turnstileToken;
        }
        const submittedChallenge = {
            ...this.request,
            SessionInfo: sessionInfo,
            UserAgentString: navigator.userAgent,
        };
        const request = {
            BankIdentifier: configuration.clientKey,
            BankInstanceIdentifier: configuration.bii,
            BankUri: configuration.bankUri,
            SubmittedChallenge: submittedChallenge,
        };
        const model = {
            Request: request,
            RedirectUrl: configuration.redirectUrl,
        };
        const url = this.getChallengeUrl(submittedChallenge, configuration.rootUrl);
        const response = await fetch(url, {
            body: JSON.stringify(model),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
        });
        if (!response.ok) {
            throw response;
        }
        return (await response.json());
    }
    getChallengeUrl(challenge, rootUrl) {
        let url;
        switch (challenge.ChallengeTypeValue) {
            case ChallengeType_1.ChallengeType.StartRegistration:
            case ChallengeType_1.ChallengeType.ChooseRegistrationType:
            case ChallengeType_1.ChallengeType.RegistrationDisclosure:
            case ChallengeType_1.ChallengeType.ConfirmIdentity:
            case ChallengeType_1.ChallengeType.UpdateBusiness:
            case ChallengeType_1.ChallengeType.CreateUsername:
            case ChallengeType_1.ChallengeType.CreateUser:
                url = `${rootUrl}API/Registration/${challenge.ChallengeTypeValue}`;
                break;
            case ChallengeType_1.ChallengeType.UsernameAndPassword:
                url = `${rootUrl}API/Isotope/Credentials`;
                break;
            case ChallengeType_1.ChallengeType.StartForgotPassword:
            case ChallengeType_1.ChallengeType.ForgotPasswordDisclosure:
            case ChallengeType_1.ChallengeType.ForgotPasswordChooseScenario:
            case ChallengeType_1.ChallengeType.ForgotPasswordConfirmIdentity:
                url = `${rootUrl}API/ForgotPassword/${challenge.ChallengeTypeValue}`;
                break;
            case ChallengeType_1.ChallengeType.StartForgotUsername:
            case ChallengeType_1.ChallengeType.ForgotUsernameChooseScenario:
            case ChallengeType_1.ChallengeType.ForgotUsernameConfirmIdentity:
                url = `${rootUrl}API/ForgotUsername/${challenge.ChallengeTypeValue}`;
                break;
            default:
                url = `${rootUrl}API/Isotope`;
                break;
        }
        return url;
    }
    // Logic after receiving the response
    postSubmitChallenge(response) {
        this.response = response;
        // If session has expired, redirect to the first page of the workflow. Set session cache with session expired key.
        // Delete it from session cache after reload
        if (response.ChallengeStatusValue === ChallengeStatus_1.ChallengeStatus.SessionExpired) {
            sessionStorage.setItem(ChallengeStatus_1.ChallengeStatus.SessionExpired, 'true');
            window.location.reload();
            return response;
        }
        if (response.NextRequestedChallenge) {
            // Used for remember device
            this.updateMachineInfo();
            // Used by FUFP for step progress
            this.getNumberOfSteps();
            this.updateCurrentStep();
            // Handle if the user account gets locked out
            if (this.handleLockout())
                return response;
            // Prepare the next challenge
            let nextChallenge = { ...response.NextRequestedChallenge };
            // Handle challenge-specific processing
            switch (response.NextRequestedChallenge.ChallengeTypeValue) {
                case ChallengeType_1.ChallengeType.Done:
                    // If Done challenge is issued, redirect the user directly
                    this.handleDoneChallenge();
                    return response;
                case ChallengeType_1.ChallengeType.StepUp:
                    this.handleStepUpChallenge();
                    break;
                case ChallengeType_1.ChallengeType.CheckSyncResult:
                    if (this.handleCheckSyncResultChallenge())
                        return response;
                    break;
                case ChallengeType_1.ChallengeType.OneTimeCode:
                    // Remain on the StepUp page for failed validations for specific types
                    // The webapp returns the challenge time at OTP which will load the One Time Code template.
                    // We want to prevent this for some cases
                    if (this.context.state.remainOnStepUpScreenOnFailure)
                        nextChallenge = this.repeatStep(nextChallenge);
                    break;
                case ChallengeType_1.ChallengeType.OneTimeCodeDestination:
                    // HasError = true means there was an issue sending stepup, so re-display the stepup challenge
                    if (response.HasError)
                        nextChallenge = this.repeatStep(nextChallenge);
                    break;
                case ChallengeType_1.ChallengeType.ForgotPasswordConfirmIdentity:
                case ChallengeType_1.ChallengeType.ForgotUsernameConfirmIdentity:
                case ChallengeType_1.ChallengeType.ConfirmIdentity:
                    if (nextChallenge.Scenario == null && this.request.ChallengeTypeValue === nextChallenge.ChallengeTypeValue) {
                        nextChallenge = this.repeatStep(nextChallenge);
                    }
                    break;
                case ChallengeType_1.ChallengeType.UsernameAndPassword:
                    if (response.ChallengeStatusValue === ChallengeStatus_1.ChallengeStatus.BotDetected && this.context.getters.initialChallengeType === ChallengeType_1.ChallengeType.Tethered) {
                        // Tethered login that failed the bot test.  Remain on the tethered screen.
                        nextChallenge = this.repeatStep(nextChallenge);
                    }
                    break;
            }
            this.context.commit('currentChallenge', nextChallenge);
            // reset the state to block transition
            this.context.commit('setRemainOnStepUpScreenOnFailure', false);
        }
        this.handleValidationErrors();
        // In some cases we can get a response with a body but no ChallengeStatusValue.
        // This check makes sure we don't commit an undefined challenge status.
        if (response.ChallengeStatusValue)
            this.context.commit('challengeStatus', response.ChallengeStatusValue);
        this.context.commit('isSubmittingChallenge', false);
        return response;
    }
    updateMachineInfo() {
        var _a, _b, _c, _d;
        if (((_d = (_c = (_b = (_a = this.response) === null || _a === void 0 ? void 0 : _a.NextRequestedChallenge) === null || _b === void 0 ? void 0 : _b.SessionInfo) === null || _c === void 0 ? void 0 : _c.AdditionalParameters) === null || _d === void 0 ? void 0 : _d.UpdateMachineInfo) === 'True') {
            MachineSecretManager_1.default.machineSecretProvider.write(this.response.NextRequestedChallenge.SessionInfo.MachineInfo);
        }
    }
    getNumberOfSteps() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        // Unfortunately I have to do this null check for the linter's sake, even though parseInt would handle a null just fine
        const numSteps = (_d = (_c = (_b = (_a = this.response) === null || _a === void 0 ? void 0 : _a.NextRequestedChallenge) === null || _b === void 0 ? void 0 : _b.SessionInfo) === null || _c === void 0 ? void 0 : _c.AdditionalParameters) === null || _d === void 0 ? void 0 : _d.NumberOfStepsRequired;
        if (numSteps == null)
            return;
        const maxSteps = parseInt(numSteps, 10);
        if (!isNaN(maxSteps) && maxSteps > 0) {
            this.context.commit('setCurrentWorkflowMaxSteps', maxSteps);
            // Since we only get the max step in the first step of the workflow, reset it back to 0 if we get it again
            // This might happen due to session expiration
            if (this.request.ChallengeTypeValue !== ((_e = this.response) === null || _e === void 0 ? void 0 : _e.NextRequestedChallenge.ChallengeTypeValue)) {
                this.context.commit('setCurrentWorkflowStep', 0);
            }
            // set the max steps in body back to 0 to prevent it from being sent back
            if (((_j = (_h = (_g = (_f = this.response) === null || _f === void 0 ? void 0 : _f.NextRequestedChallenge) === null || _g === void 0 ? void 0 : _g.SessionInfo) === null || _h === void 0 ? void 0 : _h.AdditionalParameters) === null || _j === void 0 ? void 0 : _j.NumberOfStepsRequired) != null)
                this.response.NextRequestedChallenge.SessionInfo.AdditionalParameters.NumberOfStepsRequired = '0';
        }
    }
    updateCurrentStep() {
        var _a;
        if (this.context.state.currentWorkflowMaxSteps > 0
            && this.context.state.currentWorkflowStep < this.context.state.currentWorkflowMaxSteps
            && this.request.ChallengeTypeValue !== ((_a = this.response) === null || _a === void 0 ? void 0 : _a.NextRequestedChallenge.ChallengeTypeValue)) {
            if (!this.context.state.isResendingOTP) {
                const currentStep = this.context.state.currentWorkflowStep + 1;
                this.context.commit('setCurrentWorkflowStep', currentStep);
            }
        }
    }
    handleLockout() {
        var _a, _b;
        switch ((_a = this.response) === null || _a === void 0 ? void 0 : _a.NextRequestedChallenge.ChallengeTypeValue) {
            case ChallengeType_1.ChallengeType.UsernameAndPassword: // User is being sent to the login page so ignore lockouts here - used for messaging
            case ChallengeType_1.ChallengeType.LockedUser: // User is doing forgot password and cannot self-unlock - displaying the lockout vue
                return false;
        }
        // for all other challenge types, redirect to the locked out page
        if (((_b = this.response) === null || _b === void 0 ? void 0 : _b.ChallengeStatusValue) === ChallengeStatus_1.ChallengeStatus.LockedOut) {
            // baseUrl is only set if using mobile site. If it's null, we'll need to redirect to desktop site
            const redirect = this.context.state.configuration.baseUrl ? `${this.context.state.configuration.bankUri}${this.context.state.configuration.baseUrl}\\Authentication\\LockedOut`
                : `${this.context.state.configuration.bankUri}\\Authentication\\LockedOut`;
            window.location.href = redirect;
            return true;
        }
        return false;
    }
    handleDoneChallenge() {
        var _a, _b;
        const doneChallenge = (_a = this.response) === null || _a === void 0 ? void 0 : _a.NextRequestedChallenge;
        const authCode = doneChallenge.OAuthCode;
        if (authCode !== null && authCode !== '' && window.Alkami.Helpers.isNativeApplication() && typeof ((_b = window.f_onAuthCodeReceived) === null || _b === void 0 ? void 0 : _b.postMessage) === 'function') {
            // for native applications, call the auth code channel
            window.f_onAuthCodeReceived.postMessage(JSON.stringify({ code: authCode }));
        }
        this.context.commit('isSyncing', false);
        this.context.commit('authenticatedModel', { username: doneChallenge.Username, nonce: doneChallenge.Grant });
    }
    handleStepUpChallenge() {
        var _a;
        const stepupChallenge = (_a = this.response) === null || _a === void 0 ? void 0 : _a.NextRequestedChallenge;
        this.context.commit('setShowRememberDevice', stepupChallenge.IsRememberDeviceOptionSupported);
        this.context.commit('setIsStepUpMandatory', stepupChallenge.IsStepUpMandatory);
    }
    handleCheckSyncResultChallenge() {
        var _a, _b;
        switch ((_a = this.response) === null || _a === void 0 ? void 0 : _a.ChallengeStatusValue) {
            // account sync is still in progress
            case ChallengeStatus_1.ChallengeStatus.Success:
                this.context.commit('isSyncing', true);
                this.context.state.checkSyncResultChallenge = { ...(_b = this.response) === null || _b === void 0 ? void 0 : _b.NextRequestedChallenge };
                return true;
            case ChallengeStatus_1.ChallengeStatus.SyncError:
                this.context.commit('isSyncing', false);
                break;
        }
        return false;
    }
    handleValidationErrors() {
        var _a;
        if (((_a = this.response) === null || _a === void 0 ? void 0 : _a.ValidationResults) && this.response.ValidationResults instanceof Array) {
            const errors = this.response.ValidationResults.filter((error) => {
                return error.Severity === Validations_1.Severity.Error || error.Severity === Validations_1.Severity.Fatal;
            });
            this.context.commit('errors', errors);
        }
    }
    repeatStep(nextChallenge) {
        const currentChallenge = this.context.state.challengeHistory.pop();
        if (currentChallenge && this.response) {
            nextChallenge = {
                ...currentChallenge,
                ...this.response.NextRequestedChallenge,
                ChallengeTypeValue: currentChallenge.ChallengeTypeValue,
            };
        }
        return nextChallenge;
    }
}
exports.ChallengeProcessor = ChallengeProcessor;
